import { render } from "./index.vue?vue&type=template&id=f9607dca&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=f9607dca&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=f9607dca&lang=scss"

import exportComponent from "C:\\Users\\EDZ\\Desktop\\emulator\\linux_app_emulator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9607dca"]])

export default __exports__